import { buildContentPermanentPath, ROUTES } from "@/constants/routes";
import { isVideoContent } from "@/utils/content-adapter.mjs";
import { buildPlayContext, savePlayContext } from "@/utils/play-context";

const getCurrentSourcePath = () => {
  if (typeof window === "undefined") return "";
  return `${window.location.pathname}${window.location.search}`;
};

const getContentPlaceId = (content) =>
  content?.locationTag ||
  content?.place?.id ||
  content?.place?._id ||
  content?.place?.publicId ||
  content?.placeUniqueNumber ||
  "";

export const getContentNavigationContextType = (pathname) => {
  if (pathname?.startsWith("/places") || pathname?.startsWith("/place")) {
    return "place";
  }
  if (pathname?.startsWith("/@") || pathname?.startsWith("/profile")) {
    return "profile";
  }
  if (pathname?.startsWith("/search")) return "search";
  if (
    pathname?.startsWith(ROUTES.current.play) ||
    pathname?.startsWith(ROUTES.legacy.hot)
  ) {
    return "play";
  }
  if (pathname?.startsWith("/album")) return "album";
  if (pathname?.startsWith("/admin")) return "admin";
  return "related";
};

export const openContentDetail = ({
  router,
  content,
  feed = [],
  contextType = "related",
  sourcePath,
  sourceParams,
  query = "",
  placeId = "",
  userId = "",
  categoryId = "",
  category = "",
}) => {
  if (!router || !content) return;

  const targetPath = buildContentPermanentPath(content);
  if (!targetPath) return;

  if (isVideoContent(content)) {
    savePlayContext(
      buildPlayContext({
        contextType,
        initialVideo: content,
        feed,
        sourcePath: sourcePath || getCurrentSourcePath(),
        sourceParams,
        query,
        placeId: placeId || getContentPlaceId(content),
        userId,
        categoryId: categoryId || content?.categoryId || "",
        category: category || content?.category?.name || "",
      })
    );
  }

  router.push(targetPath, { scroll: false });
};
